/**
 * Copyright © Ircam Amplify 2024-2026
 */

import { signOutUser } from '@/pages/Login'
import { signOut } from 'aws-amplify/auth'
import { Link, useNavigate } from 'react-router-dom'
import './AccountMenu.css'

function UserMenu() {
  const navigate = useNavigate()

  const signOutAndNavigate = async () => {
    await signOut()
    signOutUser()
    navigate('/login')
  }

  return (
    <div className="userMenu">
      <div className="userMenu-item">
        <Link className="userMenu-link" to="/my-account">
          My&nbsp;Account
        </Link>
      </div>
      <div className="userMenu-item userMenu-separator">|</div>
      <div>
        <div
          role="button"
          className="userMenu-logout"
          onClick={signOutAndNavigate}
          onKeyDown={signOutAndNavigate}
          tabIndex={0}
        >
          Logout
        </div>
      </div>
    </div>
  )
}

export default function AccountMenu() {
  return (
    <div className="accountMenu">
      <UserMenu />
    </div>
  )
}
